export enum CampaignAction {
    Edit = 10,
    Delete = 20,
    DownloadMailingList = 30,
    UploadMailingList = 40,
    EditColumnMapping = 50,
    //ViewMailingList = 60,
    ConfirmMailingList = 70,
    UploadSignatureFile = 80,
    ViewSignatureFile = 90,
    EditLetter = 100,
    MergeListLetter = 110,
    OrderBrochures = 120,
    DownloadBrochurePdf = 130,
    DownloadMailingFiles = 140,
    Divider = -1
}